/** @file English catalog part of area E1 (W3-03); replaced whole by that area. */

/** The `viewport` block (viewport notices, toolbar, overlay toggles). S0 composes it into `en`. */
export const viewportEn = {
  canvas: 'Skeleton viewport',
  toolbar: 'Viewport tools',
  modeSetup: 'Setup',
  modeAnimate: 'Animate',
  snap: 'Snap',
  bones: 'Bones',
  names: 'Names',
  mesh: 'Mesh',
  ik: 'IK',
  sockets: 'Sockets',
  axes: 'Axes',
  grid: 'Grid',
  onion: 'Onion skin',
  frameSelection: 'Frame selection',
  key: 'Key',
  suggestIk: 'Suggest IK',
  dismiss: 'Dismiss',
  unkeyed: 'Pose changed but not keyed: press Key (K) or turn auto-key on.',
  noAnimation: 'Choose an animation in the timeline to key the pose.',
  setupOnly: 'Switch to Setup mode for this edit.',
  socketBone: 'Socket bones follow their socket: drag the socket points with the Select tool.',
  noItem: 'Press on an item mounted on a socket.',
  noIk: 'No IK constraint ends at {bone}.',
  missingTexture: '{count} images could not be loaded; their parts are not drawn.',
  compileError: 'The latest edit does not compile; the viewport shows the last good rig.',
  autorigHint: 'This project has {n} images and no slots yet: Auto-rig builds the bones, slots and regions from them, and you review the plan before it is applied.',
  autoRig: 'Auto-rig everything',
} as const;
